import { push } from 'connected-react-router'
import { all, call, put, take, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { ROUTES } from '../../../common/Routes/routePaths'
import api from '../../../services/api.services'
import { resetPassword } from './ResetPasswordActions'
import { getWhoAmI, getWhoAmIFail, getWhoAmISuccess } from '../../../common/auth/authActions'
import { getErrorMsg } from '../../../common/helpers/translations'

function* sagaResetPassword({ payload }: any) {
  try {
    const { newPassword } = payload
    yield call(api.auth.resetPassword, { newPassword })
    yield put({ type: String(getWhoAmI) })
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])
    const notification: INotification = {
      type: 'success',
      content: t`Password successfully reset`,
    }
    yield put(push(ROUTES.LOGIN.to, { notification }))
  } catch (e: any) {
    const resetPasswordErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('password reset'),
    }
    yield put({ type: String(addNotification), payload: resetPasswordErrorNotification })
  }
}

export function* resetPasswordSagas() {
  yield all([takeEvery(String(resetPassword), sagaResetPassword)])
}
